<template>
  <div class="page-container">
    <div class="content-wrap">
      <session-expiring v-if="sessionWarning"/>
      <component :is="layout"/>
    </div>
    <es-footer/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EsFooter from '@/components/EsFooter.vue';
import SessionExpiring from '@/components/SessionExpiring.vue';

const defaultLayout = 'default';
export default {
  components: {
    EsFooter,
    SessionExpiring,
  },
  async mounted() {
    try {
      await Promise.all([
        this.initBranding(),
      ]);
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    ...mapActions({
      initBranding: 'initBranding',
    }),
  },
  computed: {
    ...mapGetters([
      'sessionWarning',
    ]),
    layout() {
      return (`${this.$route.meta.layout || defaultLayout}-layout`);
    },
  },
};
</script>

<style lang="sass">
@import "@/sass/custom.sass"
@import "~bulma/bulma"
@import "~bulma-multiselect"
@import "~bulma-extensions/bulma-checkradio/src/sass/index.sass"
@import "~bulma-extensions/bulma-calendar/src/sass/index.sass"
@import "~bulma-extensions/bulma-switch/src/sass/index.sass"
@import "@/sass/global.sass"

html, body
  min-height: 100%
  background-color: rgb(242, 242, 242)

#app
  // font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  color: #2c3e50
  height: 100%

.page-container
  position: relative
  min-height: calc(100vh)
  display: flex
  flex-direction: column

.content-wrap
  padding-bottom: 0.75rem
</style>
